import * as React from 'react';
import { Pressable, View } from 'react-native';
import { createStyleSheet, useStyles } from 'react-native-unistyles';

import { Card, Text } from '@/ui';
import { Icon } from '@/ui/icon';
import { Battery } from '@/ui/icons/battery';

interface ServiceCardProps {
  title: string;
  description: string;
  price: string;
  style?: any;
  disabled?: boolean;
  active?: boolean;
  onPress: () => void;
}

export const ServiceCard = ({
  title,
  description,
  price,
  style,
  disabled = false,
  active = false,
  onPress,
}: ServiceCardProps) => {
  const { styles, theme } = useStyles(stylesheet);
  const [hover, setHover] = React.useState(false);

  const getStyle = () => {
    const showDisabled = disabled;
    let stateStyle = styles.default;

    if (showDisabled) {
      stateStyle = styles.disabled;
    }
    if (hover) {
      stateStyle = styles.hover;
    }
    if (active) {
      stateStyle = styles.active;
    }

    return [stateStyle];
  };

  return (
    <Pressable
      style={[styles.container, style]}
      onHoverIn={() => setHover(true)}
      onHoverOut={() => setHover(false)}
      hitSlop={8}
      onPress={() => onPress?.()}
    >
      <Card style={[styles.card, getStyle()]}>
        <View style={styles.contentContainer}>
          <View style={{ flexDirection: 'row', alignItems: 'center', gap: 8 }}>
            <Icon
              type="dressed"
              icon={<Battery />}
              fillColor={theme.colors.success}
              width={25}
              height={25}
            />

            <Text type="bodyBold">{title}</Text>
          </View>

          <View>
            <Text
              type="bodyRegular"
              style={{ color: theme.colors.text.secondary }}
            >
              {description}
            </Text>
          </View>

          <View>
            <Text type="title2">{price}</Text>
          </View>
        </View>
      </Card>
    </Pressable>
  );
};

const stylesheet = createStyleSheet((theme) => ({
  container: {
    width: '100%',
    gap: 8,
  },
  card: {
    flexGrow: 1,
    flexDirection: {
      xs: 'row',
      md: 'column',
    },
    justifyContent: 'space-between',
    alignItems: {
      xs: 'center',
      md: 'flex-start',
    },
    padding: 16,
    gap: 16,
  },
  contentContainer: {
    gap: 16,
    width: {
      xs: '80%',
      md: '100%',
    },
  },
  default: {
    backgroundColor: theme.colors.card.default.backgroundColor,
    borderColor: theme.colors.card.default.borderColor,
  },
  active: {
    backgroundColor: theme.colors.card.active.backgroundColor,
    borderColor: theme.colors.card.active.borderColor,
    borderWidth: 1,
  },
  hover: {
    backgroundColor: theme.colors.card.hover.backgroundColor,
    borderColor: theme.colors.card.hover.borderColor,
  },
  disabled: {
    backgroundColor: theme.colors.card.disabled.backgroundColor,
    borderColor: theme.colors.card.disabled.borderColor,
  },
}));
